import React from 'react';

const Offer = () => (
  <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1C0 0.447715 0.447715 0 1 0H7C7.55228 0 8 0.447715 8 1V2.15H0V1ZM0 3.35H8V10L6.09643 9L4 10L1.98453 9L0 10V3.35ZM3.17495 5.40984V4.20984H1.17495V5.40984H3.17495Z"
      fill="white"
    />
  </svg>
);

export default Offer;
